import { getQuery } from './apiFunctions'

export const getTodaysDay = async () => {
  return await getQuery({
    path: '/api/today/',
    callback: (response) => response.data,
  })
}